export { default } from './index.vue';



// WEBPACK FOOTER //
// ./packages/dof-searchbar/index.js